// removed by extract-text-webpack-plugin
module.exports = {"add-lesson-dock":"add-lesson-dock","lesson-form":"lesson-form","content":"content","loading":"loading","add-lesson-class-name":"add-lesson-class-name","class-list":"class-list","searchbar-wrapper":"searchbar-wrapper","select-list":"select-list","select-item":"select-item","class-icon":"class-icon","icon-angle-right":"icon-angle-right","item-class-name":"item-class-name","fa":"fa","form-group":"form-group","form-field":"form-field"};


//////////////////
// WEBPACK FOOTER
// ./src/template/Docks/AddLesson/style.scss
// module id = 9oJb
// module chunks = 0